/*
 * Copyright (c) 2023 CalAmp Corp.  All Rights Reserved
 */
import React from 'react';
import {makeStyles} from '@material-ui/core/styles';
import classnames from 'classnames';
import {translate} from '@ion/core/src/locale/locale';
import {dlsColor, dlsTypography} from '@ion/dls/src/theme/theme';
import {NoGpsIcon} from '../../icons/NoGpsIcon';

const useStyles = makeStyles(() => {
  return {
    container : {
      display     : 'flex',
      alignItems  : 'center',
      position    : 'relative',
      top         : 3,
      paddingLeft : (isPopupContent) => isPopupContent ? 12 : 0
    },
    valueContainer : {
      display    : 'inline-block',
      fontSize   : 14,
      color      : dlsColor('grey2'),
      marginLeft : '5px',
      alignItems : 'center'
    },
    secondaryText : {
      color : dlsColor('caRed')
    },
    popupText : {
      ...dlsTypography('tags'),
      letterSpacing : '1px',
      lineHeight    : '24px'
    },
    card : {
      fontFamily    : 'Roboto',
      fontWeight    : 700,
      fontSize      : '12px',
      lineHeight    : '16px',
      letterSpacing : '1px',
      textTransform : 'uppercase'
    }
  };
});

export interface NoGpsStatusProps {
  isTextRed?: boolean;
  isPopupContent?: boolean;
  label?: string;
}

/**
 * Defines the Gps Signal status component
 *
 * ```typescript
 *
 *   import BatteryChargeLevel from '@ion/dls/src/components/battery'
 *   <BatteryChargeLevel value={value}
 *     iconId={iconId}
 *     valueComponent={valueComponent} />
 * ```
 */
export const NoGpsStatus = ({
  isTextRed = false,
  isPopupContent = false,
  label = translate('tracking:list.detailed.noGps')
}: NoGpsStatusProps) => {
  const classes = useStyles({isPopupContent});

  return (
    <div className={classes.container}>
      <NoGpsIcon />
      <div className={classnames(classes.valueContainer, {
        [classes.secondaryText] : isTextRed,
        [classes.popupText]     : isPopupContent,
        [classes.card]          : !isPopupContent
      })}>
        {label}
      </div>
    </div>
  );
};

export default NoGpsStatus;
